import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useFormContext } from '../../contexts/FormContext';

const CheckBoxField = ({ field }) => {
  const { formData, getFormDataItem, handleChange } = useFormContext();

  return (
    <Grid size={field.size || 12} key={field.name}>
      <FormControlLabel
        control={
          <Checkbox
            checked={getFormDataItem(formData, field.name) || false}
            onChange={(e) =>
              handleChange({ target: { name: field.name, value: e.target.value, type: e.target.type, checked: e.target.checked } }, field)
            }
            inputProps={{ 'aria-label': 'controlled' }}
          />
        }
        label={<Typography color={'text.primary'}>{field.label}</Typography>}
      />
    </Grid>
  );
};

export default CheckBoxField;
